export enum FlatFee {
  PerContainer = 'per_container',
  PerWeek = 'per_week',
  PerMonth = 'per_month',
}
